import BaseAPI from "../baseAPI"

class DiSanaAPI extends BaseAPI {
  constructor() {
    super("/store")
  }

  getAllProductCategories(query) {
    return this.getByQuery("/product-categories", query)
  }

  getProductByProdCategory(param) {
    return this.getByParams(`/${param.categoryId}/products`, { page: param.page })
  }

  getProductDetails(param) {
    return this.get(`/p/${param}`)
  }

  getProductRecomms(param) {
    return this.get(`/p/${param}/recommendation`)
  }

  createFaq(data) {
    return this.post("/faq/create", data)
  }
}

export { DiSanaAPI as default }